const FooterSocial = () => {
    return (
        <div className="widget">
            <h3 className="widget-title mb-30">소셜 미디어</h3>
            <ul className="social-list list-horizontal">
                <li><a href="https://discord.gg/EF7zM7qFrt"><span className="fab fa-discord" style={ {fontSize : '1.6rem'}}></span></a></li>
                <li><a href="https://www.youtube.com/@heuguchon_com"><span className="icon-youtube small"></span></a></li>
                <li><a href="https://twitter.com/heuguchon"><span className="icon-twitter small"></span></a></li>
                <li><a href="https://github.com/heuguchon"><span className="icon-github small"></span></a></li>
            </ul>
        </div>
    )
}

export default FooterSocial;